import { observer } from 'mobx-react-lite'
import { Box } from '@mui/material'
import { TeamList } from '../component/molecules/TeamList'

export const MyTeamPage = observer(() => {
  return (
    <Box sx={styles.root}>
      <TeamList />
    </Box>
  )
})

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: { xs: '1rem', md: '1rem 5rem' },
  },
}
